const convertTZ = (date, tzString) => {
  return new Date(
    (typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {
      timeZone: tzString
    })
  );
};

const convertTimeInLocalToCST = (dateString) => {
  const date = new Date(dateString);
  const res = convertTZ(date, "America/Chicago");
  return { convertedTime: res, offset: date.getHours() - res.getHours() };
};

module.exports = convertTimeInLocalToCST;
